import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import composeAbstract from '../xocs/abstract/composeAbstract';
import { setupMathJax } from '../../utils/mathJax';

export default class Abstract extends Component {
  constructor(props) {
    super(props);
    this.fetchAbstract();
  }

  componentDidUpdate() {
    this.fetchAbstract();
    setupMathJax('abstract');
  }

  fetchAbstract() {
    const {
      data,
      failed,
      fetchAbstract,
      isLoading,
    } = this.props;

    if (!data && !failed && !isLoading) {
      fetchAbstract();
    }
  }

  render() {
    const { isLoading, data } = this.props;

    if (isLoading) {
      return <div className="move-center u-margin-l-top"><Icon.Spinner /></div>;
    }

    if (!data) {
      return (
        <div className="u-margin-l-top">
          There was a problem loading the abstract for this article
        </div>
      );
    }

    const abstractComponent = typeof data === 'string'
      ? (
        <>
          <h2>Abstract</h2>
          <div>{data}</div>
        </>
      )
      : composeAbstract(data);

    return (
      <div
        className="abstract u-margin-m-ver u-margin-xs-right u-font-serif"
        id="reference-abstract"
      >
        {abstractComponent}
      </div>
    );
  }
}

Abstract.propTypes = {
  isLoading: PropTypes.bool,
  failed: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  fetchAbstract: PropTypes.func.isRequired,
};

Abstract.defaultProps = {
  isLoading: false,
  failed: false,
  data: undefined,
};
